import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {LoadingSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {MerchantButton} from "../../../../common/MerchantButton";
import {apiDeleteAddress, UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {Controller} from "../../../Controller";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {Toast} from "../../../../ui/Toast.jsx";


@autoredraw(UserAddressStore)
export class InlineUserDashboardRemoveAddressPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeAddress,
        };
    }

    async removeAddress() {
        LoadingSpinner.show();
        try {
            await apiDeleteAddress(Controller.address.selectedAddress.id);
            Router.back();
            Toast.showSuccess(Messages.addressRemoved);
        } catch (error) {
            Toast.showError(error);
        } finally {
            LoadingSpinner.hide();
        }
    }

    render() {
        const {styleSheet} = this;

        return [
            <MessageElement message={Messages.deleteAddressDescription(Controller.address.selectedAddress.toString())}/>,
            <MerchantButton className={styleSheet.actionButton} label={Messages.remove} onClick={() => this.removeAddress()}/>,
            <div className={styleSheet.backButton} onClick={() => Router.back()}>
                {Messages.cancel}
            </div>
        ];
    }
}
